import React, { createContext, useContext } from "react";
import { useAccordionContext } from "./AccordionContext";
export var AccordionItemContext = /*#__PURE__*/createContext(undefined);
export var AccordionItemProvider = function AccordionItemProvider(_ref) {
  var id = _ref.id,
    children = _ref.children;
  var _useAccordionContext = useAccordionContext(),
    openIds = _useAccordionContext.openIds,
    hydrated = _useAccordionContext.hydrated;
  return /*#__PURE__*/React.createElement(AccordionItemContext.Provider, {
    value: {
      isOpen: !hydrated || openIds.has(id),
      id: id
    }
  }, children);
};
export function useAccordionItemContext() {
  var context = useContext(AccordionItemContext);
  if (context === undefined) {
    throw new Error("useAccordionItemContext must be within AccordionItemContext Provider");
  }
  return context;
}